import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { Message } from '@andes/message';

import LabelBuilder from '../../label-builder';
import { withComponentHandler } from '../../../hocs/with-component-handler';

/**
 * PropTypes for the MessageDisplay component.
 *
 * @param {Object} props - The component props
 * @param {string} props.className - Additional CSS class names for the message container.
 * @param {boolean} props.closable - Determines if the message can be closed by the user. Defaults to `true`.
 * @param {string} props.color - Specifies the color of the message.
 * @param {string} props.messageClassName - CSS class names for the outermost container div.
 * @param {string} props.hierarchy - Defines the hierarchy level of the message (e.g., primary, secondary).
 * @param {Object} props.intervention - Data object used to build the message content.
 * @param {string} props.interventionClassName - CSS class names for the intervention-specific styling.
 * @param {string} props.listingDisclaimerClassName - CSS class names for the disclaimer section of the message.
 * @param {string} props.title - Title text displayed in the message.
 */

const MessageDisplay = ({
  className = '',
  closable = true,
  hierarchy,
  title = '',
  color = '',
  intervention,
  listingDisclaimerClassName,
  messageClassName,
  interventionClassName,
}) => (
  <div className={className}>
    <Message
      className={classnames(listingDisclaimerClassName, messageClassName, {
        [interventionClassName]: interventionClassName !== undefined,
      })}
      closable={closable}
      defaultVisible
      hierarchy={hierarchy}
      title={title}
      color={color}
    >
      <LabelBuilder {...intervention} />
    </Message>
  </div>
);

MessageDisplay.propTypes = {
  className: PropTypes.string,
  closable: PropTypes.bool,
  color: PropTypes.string,
  hierarchy: PropTypes.string,
  intervention: PropTypes.object,
  interventionClassName: PropTypes.string,
  listingDisclaimerClassName: PropTypes.string,
  messageClassName: PropTypes.string,
  title: PropTypes.string,
};

export default withComponentHandler(MessageDisplay, { componentName: 'andes-message-intervention-display' });
